// extracted by mini-css-extract-plugin
export default {"cell":"customRowValueCell_cell__MYdBr","text":"customRowValueCell_text__s3SxL","tooltip":"customRowValueCell_tooltip__nJexX"};